import LandingNav from "@/components/landing/LandingNav";
import HeroSection from "@/components/landing/HeroSection";
import FeaturesSection from "@/components/landing/FeaturesSection";
import PricingSection from "@/components/landing/PricingSection";
import FAQSection from "@/components/landing/FAQSection";
import FooterSection from "@/components/landing/FooterSection";
import StickyMobileCta from "@/components/landing/StickyMobileCta";
import Seo from "@/components/Seo";

const faqEntries = [
  { q: "Is LineupSync a free team management app?", a: "Yes. The free plan covers one team with unlimited players and staff, including scheduling, automatic RSVPs, the roster and the lineup builder. Pro is 9 EUR per team per month." },
  { q: "Who is it for?", a: "One coach or manager running a Sunday league side, a rec team or a small youth club. Clubs needing registration and subs collection are better served by a full club platform." },
  { q: "How do the automatic RSVPs work?", a: "Everyone gets a request by email when you create the event, answers in one tap without logging in, and non responders get a reminder before your deadline." },
  { q: "Do players need an account?", a: "Not to answer an event. They only create one if they want the full app." },
  { q: "How does the lineup builder work?", a: "Pick a formation and drag players onto the pitch. By default only the players who said they are coming appear on the bench. A free version is available at /lineup-builder with no account." },
  { q: "What sports does it work for?", a: "Scheduling, RSVPs and the roster work for any team sport. Formation presets currently cover football from 5 a side to 11 a side." },
  { q: "Can I run more than one team?", a: "Yes. You can switch between teams from one account, and the Club plan puts several teams under one dashboard." },
  { q: "Is my team data private?", a: "Teams are private by default, and contact details are never shown to other players. A public team page is optional." },
];

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Seo
        title="LineupSync — free team management app with automatic RSVPs"
        description="LineupSync is a free team management app for coaches. Schedule matches and training, get automatic RSVPs and reminders, then build your lineup from whoever said yes."
        path="/"
        locale="en"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqEntries.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          },
        ]}
      />
      <LandingNav />
      <main>
        <HeroSection />
        <FeaturesSection />
        <PricingSection />
        <FAQSection />
      </main>
      <FooterSection />
      <StickyMobileCta
        label="Start your free team"
        microcopy="30 sec setup · No credit card"
      />
    </div>
  );
};

export default Index;
